import React from "react";

interface PrimaryButtonProps extends React.PropsWithChildren {
  className?: string;
  onClick?: () => void;
  isDisabled?: boolean;
  textStyle?: string;
  form?: string;
  type?: "button" | "submit";
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onClick,
  className = "",
  isDisabled = false,
  textStyle = "",
  type = "button",
  form,
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      form={form}
      className={`
        group
        overflow-hidden
        bg-red
        transition-all
        duration-300
        focus:bg-red-pressed
        enabled:hover:bg-light-red
        disabled:bg-gray
        ${className}
      `}
    >
      <div className="flex items-center justify-center">
        <span
          className={`whitespace-nowrap text-button-text text-light-beige ${textStyle}`}
        >
          {children}
        </span>
      </div>
    </button>
  );
};

export default PrimaryButton;
